import form from './form.js';
import index from './index.js';
import { Router } from '@/legacy/Router';

Router.get('tier/new', form);
Router.get('tier/:any', form);
Router.get('tier', index);
